export const AppSettings = Object.freeze({
    "IS_FIREBASE_ENABLED": false,
    "SHOW_START_WIZARD": false,
    "SUBSCRIBE": false,
    "TOAST": {
        "duration": 3820,
        "position": "buttom"
      },
    "FIREBASE_CONFIG": {
      apiKey: "AIzaSyDwtd8nQF5tR5sym5FQ3gS-eKKciS9zZYU",
      authDomain: "orange-theme-ios-12.firebaseapp.com",
      databaseURL: "https://orange-theme-ios-12.firebaseio.com",
      projectId: "orange-theme-ios-12",
      storageBucket: "orange-theme-ios-12.appspot.com",
      messagingSenderId: "118710261188"
    },
    "MAP_KEY": {
        "apiKey": 'AIzaSyA4-GoZzOqYTvxMe52YQZch5JaCFN6ACLg'
    }
});



// WEBPACK FOOTER //
// ./src/services/app-settings.ts